export default {
    task: {
        getMyCash: 'నా నగదు పొందండి',
        chances: 'అవకాశాలు మిగిలి ఉన్నాయి',
        tips: 'కార్డులు పొందడానికి చిట్కాలు',
        daily: 'రోజువారీ చెక్-ఇన్',
        watch: 'ఏదైనా వీడియో చూడండి',
        share: 'పోటీని పంచుకోండి',
        free: 'ఉచిత నగదు మరియు కార్డు +1',
        done: 'చేయబడింది',
        go: 'వెళ్లండి',
        success: 'విజయవంతంగా',
        checkIn: 'చెక్ ఇన్',
        successCheckIn: 'విజయవంతంగా తనిఖీ చేయబడింది!',
        successWatched: 'విజయవంతంగా చూశారు!',
        successShared: 'విజయవంతంగా భాగస్వామ్యం చేయబడింది!',
        won: 'మీరు గెలిచారు',
        card: 'కార్డ్',
        msg: 'డబ్బు మీ అకౌంట్ కు సేవ్ చేయబడింది',
        ok: 'ఓకే',

        nochance: 'మీరు అన్నీ పూర్తి చేయలేదు',
        cards: '4 కార్డులు ',
        collection:'సేకరణ',
        watchVideo:'వీడియో చూడండి ',
        toGet:'మరింత కార్డు పొందడానికి'
    },
    
    rules: {
        ruleTitle: "రూల్స్",
        validityDate: "చెల్లుబాటు తేదీ: మార్చి 8, 2020 - మార్చి 15, 2020",
        prizeRedeem: "బహుమతి రీడీమ్: బ్యాలెన్స్ 15 రూపాయలకు చేరుకున్న తర్వాత వినియోగదారులు తమ నగదును ఉపసంహరించుకోవచ్చు, లావాదేవీ 7 పనిదినాలలో పూర్తవుతుందిగేమ్ ",
        gameRule:{
            title:"నియమాలు:",
            ruleList: [
                "1. వినియోగదారులు రోజువారీ చెక్-ఇన్ చేసినప్పుడు క్యాష్ మరియు 1 కార్డు పొందవచ్చు",
                "2. వినియోగదారులు రోజుకు ఏదైనా వీడియో చూడటం ముగించినప్పుడు క్యాష్ మరియు 1 కార్డు పొందవచ్చు",
                "3. వినియోగదారులు నగదు మరియు వారు WhatsApp సమూహం లేదా Facebook లేదా Instagram మరియు అందువలన న సూచించే భాగస్వామ్యం చేయటం ఉన్నప్పుడు -1 కార్డ్ పొందవచ్చు",
                "4. మొత్తం 4 కార్డులను సేకరించిన తర్వాత, వినియోగదారులు లాటరీని పొందే అవకాశాన్ని పొందవచ్చు. ప్రతి లక్కీ డ్రా 3 మిలియన్ రూపాయల నగదు చెరువు నుండి 100% -సూర్-విన్ లక్కీ డ్రా, ప్రతి యూజర్ గరిష్టంగా 20000 రూపాయలు డ్రా చేసుకోవచ్చుతుది వివరణ కోసం"
            ]
        },
        msg:"SHAREit అన్ని హక్కులను కలిగి ఉంది"
    },
    share: {
        title:"*తమాషా కాదు, మిత్రమా, ఈ హోలీ కోసం, SHAREit 30 లక్షల నిజమైన నగదు గివావే!*😊\n*నాతో చేరండి మరియు 20000 రూపాయల వరకు వీడియోలు చూడండి, ప్రతి ఒక్కరూ 100% గెలుస్తారు.*💰\n*నేను ఇప్పటికే ఉచిత నగదు పొందాను, ఇది 100% నిజం.*\n*ఇప్పుడు మాత్రమే SHAREit హోలీ పోటీలో చేరండి!*💕👇🏻👇🏻👇🏻"
    }
}